import styled from 'styled-components';
import { Label } from '../Label/Label';
import { ReactNode } from 'react';

type ILabelElementProps = Pick<IProps, 'isMini' | 'type'> & { hasTooltipComponent?: boolean };

const LabelElement = styled.div<ILabelElementProps>`
  .form {
    flex: 0 0 100%;
    justify-content: ${({ type, hasTooltipComponent }) =>
      hasTooltipComponent || type === 'number' || type === 'select' ? 'flex-start' : 'space-between'};
    margin-bottom: ${({ isMini, theme }) => (isMini ? '0' : theme.designToken.spacing1)};
    margin-right: ${({ isMini }) => (isMini ? '10px' : '0')};
  }
`;

interface IProps {
  name: string;
  color?: string;
  hint?: any;
  tooltipHeading?: string;
  tooltipDescription?: string | string[];
  tooltipWidth?: string;
  /** Optional tooltip description list. Deafults to undefined */
  tooltipContent?: JSX.Element;
  /** Optional tooltip to display. This replaces the existing tooltip component. */
  tooltipComponent?: ReactNode;
  disabled?: boolean;
  for?: string;
  isMini?: boolean;
  isBold?: boolean;
  /** Show the password toggle icon */
  onPasswordToggleClick?: (e: React.MouseEvent) => void;
  /** Label value for the password toggle button. Default: 'Toggle password' */
  passwordToggleLabel?: string;
  /** Is the password currently visible */
  passwordVisible?: boolean;
  type?: string;
}
export const FormItemLabel = (props: IProps) => (
  <LabelElement isMini={props.isMini} type={props.type} hasTooltipComponent={Boolean(props.tooltipComponent)}>
    <Label
      name={props.name}
      color={props.color}
      variation="form"
      hint={props.hint}
      tooltipHeading={props.tooltipHeading}
      tooltipDescription={props.tooltipDescription}
      tooltipContent={props.tooltipContent}
      tooltipWidth={props.tooltipWidth}
      tooltipComponent={props.tooltipComponent}
      disabled={props.disabled}
      for={props.for}
      isBold={props.isBold}
      onPasswordToggleClick={props.onPasswordToggleClick}
      passwordToggleLabel={props.passwordToggleLabel}
      passwordVisible={props.passwordVisible}
      type={props.type}
    />
  </LabelElement>
);
